import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {IAccessData} from '../interfaces/employee.interface';
import {EmployeeService} from '../services/employee.service';

@Injectable({
  providedIn: 'root',
})
export class AccessDataResolver  {
  constructor(private employeeService: EmployeeService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<IAccessData> {
    const employeeId = route.params['id'];
    return this.employeeService.getUserAccessData(employeeId);
  }
}
